import { graphql } from "@/graphql/generated/gql";

// ============== QUERIES ======================
export const getKeyResultQueryDocument = graphql(/* GraphQL */ `
  query GetKeyResult($input: GetKeyResultInput!) {
    keyResult(getKeyResultInput: $input) {
      id
      climateActionId
      unitId
      title
      description
      initialValue
      targetValue
      currentValue
      startDate
      targetDate
      type
      properties
      unit {
        id
        title
        symbol
      }
    }
  }
`);

// ============== MUTATIONS ======================
export const createKeyResultMutationDocument = graphql(/* GraphQL */ `
  mutation createKeyResult($input: CreateKeyResultInput!) {
    createKeyResult(createKeyResultInput: $input) {
      id
      climateActionId
      unitId
      title
      description
      initialValue
      targetValue
      currentValue
      startDate
      targetDate
      type
      properties
      unit {
        id
        title
        symbol
      }
    }
  }
`);

export const updateKeyResultMutationDocument = graphql(/* GraphQL */ `
  mutation updateKeyResult($input: UpdateKeyResultInput!) {
    updateKeyResult(updateKeyResultInput: $input) {
      id
      climateActionId
      unitId
      title
      description
      initialValue
      targetValue
      currentValue
      startDate
      targetDate
      type
      properties
      unit {
        id
        title
        symbol
      }
    }
  }
`);

export const deleteKeyResultMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteKeyResult($input: DeleteKeyResultInput!) {
    deleteKeyResult(deleteKeyResultInput: $input) {
      id
      climateActionId
      unitId
      title
      description
      initialValue
      targetValue
      currentValue
      startDate
      targetDate
      type
      properties
      unit {
        id
        title
        symbol
      }
    }
  }
`);
